import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderModule } from './header/header.module';
import { DigitalStampCardComponent } from './digital-stamp-card/digital-stamp-card.component';
import { CoreModule } from '@linkdev/shared-library';
import { CookieConsentModule } from '../cookie-consent/cookie-consent.module';

@NgModule({
  declarations: [
    FooterComponent,
    DigitalStampCardComponent   
  ],
  imports: [
    CommonModule,
    CoreModule,
    HeaderModule,
    CookieConsentModule
  ],
  exports: [
    FooterComponent,
    HeaderModule,
    DigitalStampCardComponent   
  ]
})

export class HeaderFooterModule {}
